import { render, staticRenderFns } from "./UnggahFotoComponent.vue?vue&type=template&id=418cb636&scoped=true"
import script from "./UnggahFotoComponent.vue?vue&type=script&lang=js"
export * from "./UnggahFotoComponent.vue?vue&type=script&lang=js"
import style0 from "./UnggahFotoComponent.vue?vue&type=style&index=0&id=418cb636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418cb636",
  null
  
)

export default component.exports